<template>
  <section>
    <v-container class="container-custom">
      <v-row>
        <div class="fullForm">
          <h2>Filter</h2>
          <v-form>
            <v-row>
              <v-col md="3">
                <div>
                  <v-text-field
                    v-model="productName"
                    outlined
                    placeholder="Model Name"
                  ></v-text-field>
                </div>
              </v-col>
              <v-col md="2">
                <div>
                  <v-text-field
                    v-model="minPrice"
                    outlined
                    placeholder="Min Price"
                  ></v-text-field>
                </div>
              </v-col>
              <v-col md="2">
                <div>
                  <v-text-field
                    v-model="maxPrice"
                    outlined
                    placeholder="Max Price"
                  ></v-text-field>
                </div>
              </v-col>
              <v-col md="2">
                <div>
                  <v-text-field
                    v-model="brand"
                    outlined
                    placeholder="Brand"
                  ></v-text-field>
                </div>
              </v-col>
              <v-col md="2" class="pb-0">
                <div>
                  <v-text-field
                    v-model="year"
                    outlined
                    placeholder="Year"
                  ></v-text-field>
                </div>
              </v-col>
              <v-col md="2" class="pt-0">
                <div>
                  <v-select
                    v-model="visibleStatus"
                    outlined
                    placeholder="Status"
                    :items="[
                      { name: 'Active', status: true },
                      { name: 'Deactive', status: false },
                    ]"
                    item-text="name"
                    item-value="status"
                  ></v-select>
                </div>
              </v-col>
              <v-col class="pt-0">
                <div>
                  <v-btn x-large v-if="!submitLoading" @click="filterAct"
                    >Filter</v-btn
                  >
                  <v-btn x-large loading v-if="submitLoading"></v-btn>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </div>
        <v-col md="12">
          <div class="titleAction">
            <h1 class="systemTitle">Products</h1>
            <router-link to="/business/addproduct"
              ><v-btn large>
                <v-icon class="mr-2"> mdi-plus </v-icon> Add Product</v-btn
              ></router-link
            >
          </div>

          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr class="greenBack">
                  <th class="text-left">Image</th>
                  <th class="text-left">Model Name</th>
                  <th class="text-left">Price</th>
                  <th class="text-left">Quantity</th>
                  <th class="text-left">Status</th>
                  <th class="text-left">Action</th>
                </tr>
              </thead>
              <tbody v-if="!loading">
                <tr
                  v-for="(data, index) in products"
                  :key="index + 'product'"
                  class="rowBox"
                >
                  <td width="120">
                    <img
                      v-if="data.images.length > 0"
                      :src="data.images[0].image"
                      alt=""
                      width="100"
                    />
                  </td>
                  <td>{{ data.productName }}</td>
                  <td>
                    <strong>Rs. {{ data.price }}</strong>
                  </td>
                  <td>
                    <strong>{{ data.quantity }}</strong>
                  </td>
                  <td class="text-capitalize">
                    <v-switch
                      v-model="data.visibleStatus"
                      @change="updateProduct(data)"
                    ></v-switch>
                  </td>
                  <td width="10">
                    <div class="d-flex">
                      <router-link :to="`/business/addproduct/${data._id}`"
                        ><v-icon> mdi-square-edit-outline </v-icon></router-link
                      >
                      <v-icon
                        class="ml-3"
                        v-if="!loadingDelete || id != data._id"
                        @click="removeProduct(data._id)"
                      >
                        mdi-delete
                      </v-icon>
                      <v-progress-circular
                        class="ml-3"
                        indeterminate
                        v-if="loadingDelete && id == data._id"
                        size="20"
                        width="2"
                      ></v-progress-circular>
                    </div>
                  </td>
                </tr>
              </tbody>
              <tbody v-if="loading">
                <tr>
                  <td>
                    Loading
                    <v-progress-circular
                      indeterminate
                      size="20"
                      width="2"
                      class="ml-2"
                    ></v-progress-circular>
                  </td>
                </tr>
              </tbody>
              <tfoot v-if="!loading">
                <tr>
                  <td colspan="7">
                    <ul class="pagination">
                      <li v-if="pagination.previous">
                        <v-icon @click="prev(pagination.previous)">
                          mdi-chevron-left
                        </v-icon>
                      </li>
                      <li>
                        <span v-if="pagination.previous"
                          >{{
                            pagination.previous + 1 > 1
                              ? pagination.previous + 1 * limit
                              : 1
                          }}
                          -</span
                        >
                        <span v-if="pagination.next"
                          >{{
                            pagination.next - 1 > 1
                              ? pagination.next - 1 * limit
                              : 1
                          }}
                          -</span
                        >
                        {{ pagination.total }} Items
                      </li>
                      <li v-if="pagination.next">
                        <v-icon @click="next(pagination.next)">
                          mdi-chevron-right
                        </v-icon>
                      </li>
                    </ul>
                  </td>
                </tr>
              </tfoot>
            </template>
          </v-simple-table></v-col
        >
      </v-row>
    </v-container>
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "InsuranceCompany",
  data: () => ({
    products: [],
    loading: true,
    loadingDelete: false,
    id: undefined,
    pagination: undefined,
    limit: 10,
    page: 1,
    submitLoading: false,
    productName: undefined,
    maxPrice: undefined,
    minPrice: undefined,
    status: undefined,
    brand:undefined,
    year:undefined
  }),
  computed: {
    ...mapGetters(["allProducts"]),
  },
  methods: {
    ...mapActions(["getProducts", "deleteProduct", "postProduct"]),
    async removeProduct(id) {
      this.loadingDelete = true;
      this.id = id;
      await this.deleteProduct(id);
      this.loadingDelete = false;
      this.products = this.allProducts.results;
      this.pagination = this.allProducts.pagination;
    },
    async updateProduct(data) {
      await this.postProduct({
        _id: data._id,
        visibleStatus: data.visibleStatus,
      });
    },
    async next(data) {
      this.loading = true;
      await this.getProducts({ limit: this.limit, page: data });
      this.products = this.allProducts.results;
      this.pagination = this.allProducts.pagination;
      this.loading = false;
    },
    async prev(data) {
      this.loading = true;
      await this.getProducts({ limit: this.limit, page: data });
      this.products = this.allProducts.results;
      this.pagination = this.allProducts.pagination;
      this.loading = false;
    },
    async filterAct() {
      this.submitLoading = true;
      let filter = {};
      if (this.productName != undefined) {
        filter.productName = this.productName;
      }
      if (this.maxPrice != undefined && this.maxPrice != "") {
        filter.maxPrice = this.maxPrice;
      }
      if (this.minPrice != undefined && this.minPrice != "") {
        filter.minPrice = this.minPrice;
      }
      if (this.visibleStatus != undefined) {
        filter.visibleStatus = this.visibleStatus;
      }
      if (this.brand != undefined && this.brand != "") {
        filter.brand = this.brand;
      }
      if (this.year != undefined && this.year != "") {
        filter.year = this.year;
      }
      await this.getProducts({ limit: this.limit, page: this.page, ...filter });
      this.products = this.allProducts.results;
      this.pagination = this.allProducts.pagination;
      this.submitLoading = false;
    },
  },
  async created() {
    await this.getProducts({ limit: this.limit, page: this.page });
    this.products = this.allProducts.results;
    this.pagination = this.allProducts.pagination;
    this.loading = false;
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/global.scss";
.pagination {
  list-style: none;
  padding-left: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  .v-icon {
    font-size: 18px;
    height: 30px;
    width: 30px;
    display: flex;
  }
}
.titleAction {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  a {
    text-decoration: none;
  }
}
.rowBox {
  td {
    padding: 10px !important;
  }
}
.fullForm {
  margin-top: 20px;
  width: 100%;
  // height: 100px;
  padding: 0 15px;
  h2 {
    margin-bottom: 10px;
  }
}
</style>